"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = require("styled-components");
var _Text = require("../Text");
var _Card = require("./Card.styles");
var _theme = require("../utils/theme");
var _core = require("@qwkin/core");
var _image = require("@qwkin/image");
var _excluded = ["theme", "children", "title", "titleType", "titleMinWidth", "header", "actions", "s3Key", "s3Bucket", "elevation", "scrollable", "visible", "padding"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Card = function Card(_ref) {
  var _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? _theme.defaultTheme : _ref$theme,
    children = _ref.children,
    title = _ref.title,
    _ref$titleType = _ref.titleType,
    titleType = _ref$titleType === void 0 ? 'subtitle' : _ref$titleType,
    _ref$titleMinWidth = _ref.titleMinWidth,
    titleMinWidth = _ref$titleMinWidth === void 0 ? '200px' : _ref$titleMinWidth,
    header = _ref.header,
    actions = _ref.actions,
    s3Key = _ref.s3Key,
    s3Bucket = _ref.s3Bucket,
    _ref$elevation = _ref.elevation,
    elevation = _ref$elevation === void 0 ? 'none' : _ref$elevation,
    scrollable = _ref.scrollable,
    _ref$visible = _ref.visible,
    visible = _ref$visible === void 0 ? true : _ref$visible,
    padding = _ref.padding,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    headerBackground = _useState2[0],
    setHeaderBackground = _useState2[1];
  (0, _react.useEffect)(function () {
    _core.API.fromS3(s3Bucket, s3Key).then(function (file) {
      setHeaderBackground((0, _image.bufferArrToBase64)(file.Body));
    })["catch"](function (e) {
      console.log(e);
      setHeaderBackground(null);
    });
  }, [s3Key]);
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(_Card.CardContainer, (0, _extends2["default"])({}, props, {
    elevation: elevation,
    padding: padding
  }), title && /*#__PURE__*/_react["default"].createElement(_Card.PlainHeader, {
    headerBackground: headerBackground,
    padding: padding
  }, /*#__PURE__*/_react["default"].createElement(_Text.Text, {
    weight: "bold",
    color: headerBackground ? '#FFFFFF' : theme.color.black,
    type: titleType,
    style: {
      minWidth: titleMinWidth
    }
  }, title), actions && actions), header && /*#__PURE__*/_react["default"].createElement(_Card.HeaderContainer, {
    padding: padding
  }, header), /*#__PURE__*/_react["default"].createElement(_Card.PlainCard, (0, _extends2["default"])({}, props, {
    visible: visible,
    title: title,
    scrollable: scrollable,
    padding: padding
  }), visible && children)));
};
var _default = exports["default"] = Card;